import { render, staticRenderFns } from "./PaintlistforproductPage.vue?vue&type=template&id=c4d9f4cc"
import script from "./PaintlistforproductPage.vue?vue&type=script&lang=js"
export * from "./PaintlistforproductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports